import React, { useState } from 'react';
import { useAmp } from 'next/amp';
import Styles from './PaginationBullets.css';

function PaginationBullets({
  value,
  startAtOne,
  bulletSize,
  clickable,
  ampStateKey,
  carouselId,
  id,
  activeIndex,
  onBulletClick,
  ariaLabelBullet,
  ...props
}) {
  const isAmp = useAmp();
  const items = [];

  for (let index = 0; index < value; index++) {
    if (!!startAtOne) {
      items.push(index + 1);
    } else {
      items.push(index);
    }
  }

  function getClassName(i, active = false) {
    let className = 'bullet';
    className += ` bullet-${i}`;
    className += ` ${i === items.length - 1 ? 'remove-margin' : '#'}`;
    className += ` ${clickable ? 'clickable' : '#'}`;
    className += ` ${active ? 'active' : '#'}`;
    return className.trim().replace(/\#/gi, '');
  }

  if (value < 2) {
    return <></>;
  }

  const Bullets = (
    <>
      {items.map((i) => {
        const extraProps = i === 0 && isAmp ? { selected: true } : {};

        return (
          <div
            on={`tap:${carouselId}.goToSlide(index=${i})`}
            role="button"
            tabIndex="0"
            key={`bullet-item-${i}`}
            aria-label={ariaLabelBullet[i] || `Ir para o slide ${i + 1}`}
            option={i.toString()}
            className={getClassName(i, activeIndex === i)}
            {...extraProps}
            onClick={(ev) => {
              ev.preventDefault();
              if (onBulletClick) {
                onBulletClick(i);
              }
            }}
            style={{
              ...props.style,
              height: `${bulletSize}px`,
              width: `${bulletSize}px`,
              borderRadius: `${bulletSize}px`,
            }}
          />
        );
      })}
    </>
  );

  return (
    <>
      {isAmp ? (
        <amp-selector className="pagination-container" id={id}>
          {Bullets}
        </amp-selector>
      ) : (
        <div className="pagination-container" id={id}>
          {Bullets}
        </div>
      )}

      <style jsx>{Styles}</style>
    </>
  );
}

PaginationBullets.defaultProps = {
  id: 'bullet-pagination-selector',
  value: 0,
  startAtOne: false,
  bulletSize: 12,
  ampStateKey: 'bulletsGenericStateKey',
  clickable: true,
  carouselId: 'placeholder-carousel-state',
  onBulletClick: () => {},
  ariaLabelBullet: [],
};

export default PaginationBullets;
